import React from 'react';

import dayjs from 'dayjs';

import { DateCellProps } from '../../../../../types/FieldNomsSwingContract.type';
import DATEFORMAT from '../../../../../utils/dateFormat';

const DateCell: React.FC<DateCellProps> = ({ date }) => {
  return <>{dayjs(date).format(DATEFORMAT.dayMonthYearWithSingle)}</>;
};

export default DateCell;
